import { ApiGetParams } from './api.service';

export function buildExportTimestamp(now: Date = new Date()): string {
  return now
    .toLocaleString()
    .replace(/[/,:]/g, '_')
    .replace(/\s/g, '_')
    .replace(/\./g, '');
}

export function buildExportFilename(
  exportName: string,
  now: Date = new Date(),
  extension = 'csv',
): string {
  return `${exportName}_export_${buildExportTimestamp(now)}.${extension}`;
}

export function exportIdFilter(ids: readonly string[]): ApiGetParams | undefined {
  return ids.length ? { 'filter[_id]': ids.join(',') } : undefined;
}
